export default __webpack_public_path__ + "static/media/darktemplarbg.70e2db96.jpg";